import { render } from "./planningTicket.vue?vue&type=template&id=18691e94"
import script from "./planningTicket.vue?vue&type=script&lang=ts"
export * from "./planningTicket.vue?vue&type=script&lang=ts"
script.render = render

export default script